import React from 'react';

import { SVGProps } from './SVGProps';

const SearchIcon = ({ className, color = '#999999' }: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M13 11.5H12.21L11.93 11.23C12.91 10.09 13.5 8.61 13.5 7C13.5 3.41 10.59 0.5 7 0.5C3.41 0.5 0.5 3.41 0.5 7C0.5 10.59 3.41 13.5 7 13.5C8.61 13.5 10.09 12.91 11.23 11.93L11.5 12.21V13L16.5 17.99L17.99 16.5L13 11.5ZM7 11.5C4.51 11.5 2.5 9.49 2.5 7C2.5 4.51 4.51 2.5 7 2.5C9.49 2.5 11.5 4.51 11.5 7C11.5 9.49 9.49 11.5 7 11.5Z"
        fill={color}
      />
    </svg>
  );
};

export default SearchIcon;
